// LOW-STOCK OBSERVER – works on infinite scroll
document.addEventListener('DOMContentLoaded', () => {
  const THRESHOLD = 5;

  const updateCard = (card) => {
    const stockEl = card.querySelector('.product-card__stock');
    if (!stockEl) return;

    const qty = parseInt(stockEl.dataset.stockQty, 10) || 0;
    const threshold = parseInt(stockEl.dataset.threshold, 10) || THRESHOLD;

    if (qty <= 0) {
      stockEl.innerHTML = '<span style="color:#999; text-decoration:line-through;">Sold out</span>';
      stockEl.style.display = 'block';
    } else if (qty <= threshold) {
      stockEl.innerHTML = `<span style="color:#d32f2f;">Hurry – only ${qty} left!</span>`;
      stockEl.style.display = 'block';
    } else {
      stockEl.style.display = 'none';
    }
  };

  // Initial run
  document.querySelectorAll('product-card').forEach(updateCard);

  // Variant change (Drive fires this on every card)
  document.addEventListener('variant:changed', (e) => {
    const card = e.target.closest('product-card');
    if (!card) return;

    const stockEl = card.querySelector('.product-card__stock');
    if (!stockEl) return;

    const variant = e.detail.variant;
    const qty = variant.inventory_quantity || 0;

    stockEl.dataset.stockQty = qty;
    if (qty <= 0) {
      stockEl.innerHTML = '<span style="color:#999; text-decoration:line-through;">Sold out</span>';
      stockEl.style.display = 'block';
    } else if (qty <= THRESHOLD) {
      stockEl.innerHTML = `<span style="color:#d32f2f;">Hurry – only ${qty} left!</span>`;
      stockEl.style.display = 'block';
    } else {
      stockEl.style.display = 'none';
    }
  });

  // Watch for newly added cards (infinite scroll / pagination)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mut) => {
      mut.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches('product-card')) updateCard(node);
        node.querySelectorAll && node.querySelectorAll('product-card').forEach(updateCard);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
});